import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    DELETE_TABLE,
    DELETE_TABLE_SUCCESS,
    DELETE_TABLE_ERROR
}
    from "../../actions/table";

function* deleteTableSaga(action) {
    try {
        yield put({
            type: DELETE_TABLE_SUCCESS,
            payload: action.payload.table
        });
        yield call(tableService.DeleteTable, action.payload)
      

    } catch (error) {
        yield put({
            type: DELETE_TABLE_ERROR,error: error.data
        });
    }
}


export function* deleteTableSagaWatcher() {
    yield takeLatest(DELETE_TABLE, deleteTableSaga);
}